<div class="message">{{'web.order.basketalreadyhasitems' | translate}}</div>
<button class="ui-button" mat-dialog-close>{{'web.cancel' | translate}}</button>
<button class="ui-button success" mat-dialog-close="true">{{'web.add' | translate}}</button>